<template>
  <div>
    <!-- modal queue -->
    <b-modal
      v-model="open"
      has-modal-card
      trap-focus
      full-screen
      :can-cancel="false"
      :destroy-on-hide="false"
    >
      <div class="modal-card">
        <header class="modal-card-head is-flex">
          <p class="modal-card-title mb-3">Hoje</p>
          <button
            type="button"
            class="delete"
            @click="$parent.queueState = false"
          />
        </header>
        <section class="modal-card-body">
          <!-- filters -->
          <b-field>
            <b-radio-button
              v-model="filterQueue"
              native-value="waiting"
              type="is-info is-light is-outlined"
            >
              <b-icon icon="account-clock-outline"></b-icon>
              <span>Em Espera</span>
              <b-tag rounded>{{ totalWaiting }}</b-tag>
            </b-radio-button>

            <b-radio-button
              v-model="filterQueue"
              native-value="scheduled"
              type="is-info is-light is-outlined"
            >
              <b-icon icon="account-calendar-outline"></b-icon>
              <span>Agendados</span>
              <b-tag rounded>{{ totalScheduled }}</b-tag>
            </b-radio-button>

            <b-radio-button
              v-model="filterQueue"
              native-value="attended"
              type="is-info is-light is-outlined"
            >
              <b-icon icon="account-check-outline"></b-icon>
              Atendidos
              <b-tag rounded>{{ totalAttended }}</b-tag>
            </b-radio-button>
          </b-field>
          <b-table
            :data="filteredQueue"
            :row-class="
              (row, index) => row.queueStatus == 'waiting' && 'waiting'
            "
            focusable
          >
            <!--scheduled -->
            <b-table-column label="Agendado para" v-slot="props">
              {{ props.row.start | toTime }}
            </b-table-column>
            <!--patient -->
            <b-table-column
              label="Paciente"
              :searchable="true"
              field="patient.name"
              v-slot="props"
            >
              <b-icon
                v-show="props.row.queueStatus == 'scheduled'"
                icon="account-outline"
              >
              </b-icon>
              <b-icon
                v-show="props.row.queueStatus == 'waiting'"
                icon="account-clock-outline"
              >
              </b-icon>
              <b-icon
                v-show="props.row.queueStatus == 'attended'"
                icon="account-check-outline"
              >
              </b-icon>
              {{ props.row.patient.name }}
              <br />{{ props.row.patient.covenant }}
            </b-table-column>
            <!--buttons -->
            <b-table-column v-slot="props" custom-key="actions">
              <div class="buttons">
                <!-- put on hold -->
                <b-tooltip
                  v-show="
                    user.role != 'doctor' &&
                    props.row.queueStatus == 'scheduled'
                  "
                  label="Colocar em Espera"
                  type="is-info"
                >
                  <b-button @click.prevent="setQueue(props.row.id, 'waiting')">
                    <b-icon icon="account-clock"> </b-icon>
                  </b-button>
                </b-tooltip>
                <div v-show="user.role == 'doctor'">
                  <!-- call patient -->
                  <b-tooltip
                    v-show="props.row.queueStatus != 'scheduled'"
                    label="Chamar Paciente"
                    type="is-info"
                  >
                    <b-button @click.prevent="call(props.row)">
                      <b-icon icon="monitor-share"> </b-icon>
                    </b-button>
                  </b-tooltip>
                  <!-- service completed  -->
                  <b-tooltip
                    v-show="props.row.queueStatus != 'attended'"
                    label="Concluido"
                    type="is-info"
                  >
                    <b-button
                      @click.prevent="setQueue(props.row.id, 'attended')"
                    >
                      <b-icon
                        class="has-text-danger"
                        icon="account-check-outline"
                      >
                      </b-icon>
                    </b-button>
                  </b-tooltip>
                </div>
              </div>
            </b-table-column>
          </b-table>
        </section>
      </div>
    </b-modal>
    <audio ref="queue_audio">
      <source src="./../assets/queue.mp3" type=audio/mpeg>
    </audio>
  </div>
</template>
<script>
import { SnackbarProgrammatic as Snackbar } from "buefy";
export default {
  name: "Queue",
  props: ["queueState"],
  data() {
    return {
      open: false,
      filterQueue: "waiting",
      waiting: 0,
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    queue() {
      return this.$store.getters.queue;
    },
    filteredQueue() {
      return this.queue.filter((f) => f.queueStatus == this.filterQueue);
    },
    totalScheduled() {
      if (!this.queue) return [];
      return this.queue.filter((f) => f.queueStatus == "scheduled").length;
    },
    totalWaiting() {
      if (!this.queue) return [];
      return this.queue.filter((f) => f.queueStatus == "waiting").length;
    },
    totalAttended() {
      if (!this.queue) return [];
      return this.queue.filter((f) => f.queueStatus == "attended").length;
    },
    calendarParams() {
      return this.$store.getters.calendarParams;
    },
  },
  watch: {
    queueState: function (newValue) {
      //retorna a sala de espera para a clinica ou office
      if (newValue) if (newValue) this.getQueue();
      this.open = newValue;
    },
    totalWaiting: function (newValue, OldValue) {
      if (this.user.role == "doctor" && newValue > OldValue)
        this.$refs.queue_audio.play();
    },
  },
  mounted() {
    //retorna a sala de espera para a clinica ou office
    if (this.calendarParams.office._id)
      this.getQueue(this.calendarParams.office._id);

    //atualizaa a fila via socket
    this.sockets.subscribe("updateQueue", (data) => {
      if (
        data.uid == this.user._id &&
        this.calendarParams.office._id != data.updates[0].officeId
      )
        return;
      this.getQueue();
    });
    //disparado quando o profissional faz um chamado
    this.sockets.subscribe("callPatient", (data) => {
      if (this.user.role != "doctor") {
        let messages = data.updates[0].message.split("|");
        this.$refs.queue_audio.play();
        Snackbar.open({
          indefinite: true,
          message: `<p class='has-text-white has-text-left mb-1'>${messages[0]}</p><p class='has-text-left'>Sala: ${messages[1]}</p>`,
          queue: false,
          actionText: "Ok",
        });
      }
    });
  },
  filters: {
    toTime(v) {
      if (!v) return;
      return new Date(v).toLocaleString("pt-BR", {
        hour: "2-digit",
        minute: "2-digit",
        timeZone: "UTC",
      });
    },
  },
  methods: {
    //retorna a sala de espera para a clinica ou office
    getQueue() {
      if (!this.calendarParams.office._id) return;
      this.$http
        .get(`queue/${this.calendarParams.office._id}`)
        .then((response) => {
          this.$store.commit("queue", response.data);
        });
    },
    //chama o paciente no(s) terminais que o doctor esta setado
    call(event) {
      this.$http
        .post(`event/call`, {
          officeNo: this.calendarParams.office.officeNo,
          text: event.patient.name,
          maxqueue: this.calendarParams.office.maxqueue,
          eventId: event.id,
          officeId: event.officeId,
        })
        .then(() => {
          this.$parent.queueState = false;
        });
    },

    //adiciona um evento na fila
    setQueue(eventId, newStatus) {
      //event.date = new Date().toISOString(); // DateTime.now({ zone: "utc" }).toISO();
      this.$http
        .put(`queue/${eventId}`, { queueStatus: newStatus })
        .then(() => {
          let currentQueue = this.queue.find((f) => f.id == eventId);
          currentQueue.queueStatus = newStatus;
          //this.updateQueue(response.data);
        });
    },
  },
};
</script>
<style>
label.b-radio span.tag {
  margin-left: 0.25em !important;
}
tr.waiting {
  background: #effaf5 !important;
  color: #48c78e !important;
}
</style>


